import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Dropdown, Modal } from 'react-bootstrap';
import * as DateFns from 'date-fns';

import Table, { RowType } from '../../Shared/CustomTable';
// import ConfirmationModal from '../../Shared/Modals/ConfirmationModal';
// import { SERVER } from '../../../config/server.config';
import { fixDecimals, getFile, paramBuilder } from '../../../helpers';
import { LEAGUES } from '../../../config/constants';
import { useRouter } from '../../../helpers/customHooks';
import { GameTable, OpponentData, ScoreData } from '../types';
import { SERVER } from 'config/server.config';
import ConfirmationModal from 'components/Shared/Modals/ConfirmationModal';
import { message, notification } from 'antd';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';

export default ({ games, setModal, league }: GameTable) => {

  const{ download } = useFlagsState();
  const {  fileIsDownloading } = useFlagsDispatch();
  const { location } = useRouter();
  const [downloading, setDownloading] = useState(false); 

    // Exports Notification
    const notificationKey = 'downloadFinished';
    const notificationDownload = (name:string) => {
      const args = {
        key: notificationKey,
        message: 'Download In Progress',
        description:
          `Your file ${name} is being processed.`,
        duration: 0,
        icon: <i className='mdi mdi-download' style={{color: '#0378bf'}}></i>
      };
      notification.open(args);
    };
    const notificationDownloadFinish = (name:string) => {
      const args = {
        key: notificationKey,
        message: 'Download Finished',
        description: `Your file ${name} has been downloaded successfully.`,
        duration: 4,
        icon: <i className='mdi mdi-check-underline' style={{color: '#0378bf'}}></i>
      };
      notification.open(args);
    };
    const notificationDownloadError = (name:string) => {
      const args = {
        key: notificationKey,
        message: `Error downloading file ${name}`,
        duration: 4,
        icon: <i className='mdi mdi-alert' style={{color: 'red'}}></i>
      };
      notification.open(args);
    };
  
  const exportCsv = async (id:string, params:any) => {
    fileIsDownloading(true);
    notificationDownload(`${id}.csv`);
    const done = await getFile(SERVER.CSV_REPORT(id) + paramBuilder(params), `${id}.csv`);
    if (done) {
      fileIsDownloading(false);
      notificationDownloadFinish(`${id}.csv`);
    } else {
      notificationDownloadError(`${id}.csv`);
    }
  };

  const gameRows: RowType[] = [];
  const gameHeaders = [
    //{class: 'oo-i', isCheckboxCell: true, isSelectable: true, width:'44px', minWidth: '44px', maxWidth:'44px'}, //isCheckboxCell: put in content a checkbox, isSelectable: select all or nothing
    {
      content: 'GAME',
      isOrderly: true,
      style: { paddingLeft: '20px', width: '191px' },
      leftSortIcon: '26px'
    },
    ...(league === LEAGUES.NFL) ? [{
      content: 'SCORE',
      style: { width: '115px' },
      isOrderly: true,
      leftSortIcon: '16px'
    }] : [],
    { content: 'DATE/TIME', style: { width: '135px' }, isOrderly: true, leftSortIcon: '28px' },
    { content: 'AVG. MAX SPEED', style: { width: '87px' }, class: 'll-pp', isOrderly: true },
    {
      content: 'AVG. MAX SUST. SPEED',
      style: { width: '87px' },
      class: 'll-pp',
      isOrderly: true
    },
    { content: 'AVG. TTL DIST.', style: { width: '75px' }, class: 'll-pp', isOrderly: true },
    // {content: 'AVG. HARD EFF. DIST.', style: {width: '6.}5%', class: 'll-pp', isOrderly: true},
    { content: 'AVG. ACCEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true },
    { content: 'AVG. DECEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true },
    { content: '', style: { width: league === LEAGUES.NFL ? '482px' : '597px' } }
  ];

  games.forEach((game, index) => {
    const isAway = !game.local;
    gameRows.push({
      columns: [
        //{class: 'oo-i', isCheckboxCell: game.completed, width:'44px', minWidth: '44px', maxWidth:'44px'},
        ...(league === LEAGUES.NFL) ? [{
          content: {
            opponentNick: game.opponentTeamNickname,
            opponentAbbr: game.opponentTeamAbbrName
          },
          print: (content: OpponentData) => {
            let component = <label className="l-c" style={{ cursor: 'pointer' }}>{isAway ? '@ ' : 'vs '}
              <img src={`/assets/images/logos/${content.opponentAbbr}.svg`} alt="" width="20px" />
              <b>{content.opponentAbbr + ' ' + content.opponentNick}</b>
            </label>;
            if (game.metrics) {
              component = <Link
                to={{
                  pathname: `/view/game/${game.gameId}/${isAway ? game.metrics.homeTeamId : game.metrics.awayTeamId}/performance/expanded/page`,
                  state: {
                    toReturn: location.pathname,
                    toReturnSearch: location.search,
                  }
                }}
              >
                <label className="l-c" style={{ cursor: 'pointer' }}>{isAway ? '@ ' : 'vs '}
                  <img src={`/assets/images/logos/${content.opponentAbbr}.svg`} alt="" width="20px" />
                  <b>{content.opponentAbbr + ' ' + content.opponentNick}</b>
                </label>
              </Link>;
            }
            return component;
          },
          order: (contentA: OpponentData, contentB: OpponentData) => contentA.opponentNick.localeCompare(contentB.opponentNick),
          style: { paddingLeft: '20px' }
        }] : [{
          // NCAA game format
          content: game.teamName,
          style: { paddingLeft: '20px' },
          print: (content: string) => {
            if (game.metrics) {
              return (
                <Link
                  to={{
                    pathname: `/view/game/${game.gameId}/${game.metrics.homeTeamId}/performance/expanded/page`,
                    state: {
                      toReturn: location.pathname,
                      toReturnSearch: location.search,
                    }
                  }}
                >
                  <b>{content}</b>
                </Link>
              );
            } else {
              return <b>{content}</b>;
            }
          }
        }],
        ...(league === LEAGUES.NFL) ? [{
          content: {
            ownScore: game.teamScore,
            sort: !game.completed ? -1 : game.teamScore,
            opponentScore: game.opponentTeamScore,
            win: game.teamScore > game.opponentTeamScore
          },
          print: (content: ScoreData) => {
            let component = (
              <label className="l-c">
                {content.win ? <span className="s-g">W</span> : <span className="s-r">L</span>}
                <b>{' ' + content.ownScore}</b>-{content.opponentScore}
              </label>
            );
            if (!game.completed) {
              component = (
                <label className="l-c" style={{ color: '#778893' }}>
                  Game not completed
                </label>
              );
            }
            return component;
          },
          order: (contentA: ScoreData, contentB: ScoreData) => +contentB.sort - +contentA.sort
        }] : [],
        {
          content: { startDate: game.startDate },// style: {width: '12%'}
          print: (content) => <label
            className="l-c"
          >{DateFns.format(new Date(content.startDate), 'MM/dd/yyyy, hh:mmaaaaa\'m\'')}</label>,
          order: (contentA, contentB) => contentA.startDate - contentB.startDate
        },
        {
          class: 'll-pp',
          content: {
            printAveSpeedMPH: game.metrics && game.completed ? fixDecimals(game.metrics.aveMaxSpeedMPH, 1) : '-',
            aveSpeedMPH: game.metrics && game.completed ? fixDecimals(game.metrics.aveMaxSpeedMPH, 1) : -100000
          },
          print: (content) => {
            return <label className="l-c">{content.printAveSpeedMPH}</label>;
          },
          order: (contentA, contentB) => contentA.aveSpeedMPH - contentB.aveSpeedMPH
        },
        {
          class: 'll-pp',
          content: {
            aveMaxSustainedSpeed: game.metrics && game.completed ? game.metrics.aveMaxSustainedSpeedMPH : -100000,
            printAveMaxSustainedSpeed: game.metrics && game.completed ? fixDecimals(game.metrics.aveMaxSustainedSpeedMPH, 1) : '-'
          },
          print: (content) => <label className="l-c">{content.printAveMaxSustainedSpeed}</label>, //style: {width: '8%'}
          order: (contentA, contentB) => contentA.aveMaxSustainedSpeed - contentB.aveMaxSustainedSpeed
        },
        {
          class: 'll-pp',
          content: {
            aveDistYards: game.metrics && game.completed ? game.metrics.totalAveDist : -100000,
            printAveDistYards: game.metrics && game.completed ? fixDecimals(game.metrics.totalAveDist, 1) : '-'
          },
          print: (content) => <label className="l-c">{content.printAveDistYards}</label>,// style: {width: '7%'},
          order: (contentA, contentB) => contentA.aveDistYards - contentB.aveDistYards
        },
        // {
        //   class: 'll-pp',
        //   content: {
        //     aveHardEffortDist: game.metrics && game.completed ? game.metrics.aveHardEffortDist : -100000,
        //     printAveHardEffortDist: game.metrics && game.completed ? twoDigits(game.metrics.aveHardEffortDist) : '-',
        //   },
        //   print: (content) => <label className="l-c">{content.printAveHardEffortDist}</label>, //style: {width: '6.5%'}
        //   order: (contentA, contentB) => contentA.aveHardEffortDist - contentB.aveHardEffortDist,
        // },
        {
          class: 'll-pp',
          content: {
            aveAccel: game.metrics && game.completed ? game.metrics.totalAveAccels : -100000,
            printAveAccel: game.metrics && game.completed ? fixDecimals(game.metrics.totalAveAccels, 0) : '-'
          },
          print: (content) => <label
            className="l-c"
          >{content.printAveAccel}</label>,
          order: (contentA, contentB) => contentA.aveAccel - contentB.aveAccel
        },
        {
          class: 'll-pp',
          content: {
            aveDecel: game.metrics && game.completed ? game.metrics.totalAveDecels : -100000,
            printAveDecel: game.metrics && game.completed ? fixDecimals(game.metrics.totalAveDecels, 0) : '-'
          },
          print: (content) => <label
            className="l-c"
          >{content.printAveDecel}</label>,
          order: (contentA, contentB) => contentA.aveDecel - contentB.aveDecel
        },
        {
          class: 'oo-u',
          content: game.completed && game.metrics ? (
            <>
              <Dropdown className="a-export export-button-list-games">
               <Dropdown.Toggle id="dropdown-basic" className="arrow-dropdown-position btn-blue" disabled={download}>
               Export
               </Dropdown.Toggle>
               <Dropdown.Menu>
               <Dropdown.Item
               onClick={() => exportCsv(game.gameId, { teamId: game.metrics.homeTeamId,  teamOfInterest: game.metrics.homeTeamId, 
                gameView: 'quarters', tzOffset: -(new Date(game.startDate).getTimezoneOffset()) })}
               >
               Home Export
               </Dropdown.Item>
               {league === LEAGUES.NFL && (
               <Dropdown.Item
               onClick={() => exportCsv(game.gameId, { teamId: game.metrics.awayTeamId, teamOfInterest: game.metrics.awayTeamId, 
                gameView: 'quarters', tzOffset: -(new Date(game.startDate).getTimezoneOffset()) })}
               >
               Away Export
               </Dropdown.Item>
               )}
               <Dropdown.Item
               onClick={() => exportCsv(game.gameId, { teamId: game.metrics.homeTeamId, gameView: 'plays', tzOffset: -(new Date(game.startDate).getTimezoneOffset()) })}
               >
               Home Plays Export
               </Dropdown.Item>
               <Dropdown.Item
               onClick={() => exportCsv(game.gameId, { teamId: game.metrics.awayTeamId, gameView: 'plays', tzOffset: -(new Date(game.startDate).getTimezoneOffset()) })}
               >
               Away Plays Export
               </Dropdown.Item>
               </Dropdown.Menu>
               </Dropdown>
              <Link
                to={{
                  pathname: `/view/game/${game.gameId}/${(!isAway || league !== LEAGUES.NFL) ? game.metrics.homeTeamId : game.metrics.awayTeamId}/performance/expanded/page`,
                  state: {
                    toReturn: location.pathname,
                    toReturnSearch: location.search,
                  }
                }}
              >
                <Button className="btn-blue">View Full Game Data</Button>
              </Link>
            </>) : <></>
          //style: {width: '40%'}
        }
      ],
      id: game.gameId+index
    });
  });

  return (
    <Table
      forceScope={'GAME:' + league}
      classTable="games-list-table"
      headers={gameHeaders}
      default={{ orderColumn: league === LEAGUES.NFL ? -3 : -2 }}
      rows={gameRows}
      isSelectedStyle
    />
  );
};
